<template>
  <div class="sidebar">
    <div>
      <div class="sidebar-header">
        <img v-if="!isLogoLoading" :src="tenant.getLogo || whiteLogo" alt="Tenant Logo" @error="handleLogoError" @load="handleLogoLoad" :style="{ width: '100px', height: '100px' }" />
        <div v-else class="logo-placeholder"></div>
      </div>
      <ul class="menu-list">
        <li v-for="item in menuItems" :key="item.text" :class="{ active: item.active }">
          <a href="#" class="menu-item" @click.prevent="setActive(item)">
            <img :src="item.icon" alt="Maxxxified Logo" />
            <span class="menu-text"> {{ $t(`sidebar.menu.${item.text.replace(/\s+/g, '').toLowerCase()}`) }} </span>
          </a>
        </li>
      </ul>
    </div>

    <div>
      <ul class="menu-list bottom">
        <!-- <li>
          <a href="#" class="menu-item">
            <img :src="helpIcon" alt="Maxxxified Logo" />
            <span class="menu-text"> Help </span>
          </a>
        </li> -->
        <li>
          <a href="#" class="menu-item" @click.prevent="toggleProfilePopover">
            <div class="profileDiv">
              <span class="profileText">{{ profileInitials }}</span>
            </div>

            <span class="menu-text">{{ $t('sidebar.profile') }}</span>
          </a>

          <!-- Profile Popover -->
        </li>
      </ul>
    </div>
  </div>

  <!-- Logout Confirmation Modal -->
  <div v-if="showLogoutConfirm" class="logout-modal-overlay">
    <div class="logout-modal">
      <div class="logout-icon">
        <img :src="logoutIcon" class="mainLogoutIcon" alt="" />
      </div>
      <div class="logout-title">{{ $t('sidebar.logout') }}</div>
      <div class="logout-message">{{ $t('sidebar.logout_confirm') }}</div>
      <div class="logout-actions">
        <button class="cancel-btn" @click="showLogoutConfirm = false">{{ $t('sidebar.cancel') }}</button>
        <button class="logout-btn" @click="confirmLogout">{{ $t('sidebar.yes_logout') }}</button>
      </div>
    </div>
  </div>

  <div v-if="showProfilePopover" class="profile-popover">
    <div class="profile-header">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M24.5 14C24.5033 16.0846 23.8833 18.1225 22.7197 19.852C21.76 21.2835 20.4623 22.4565 18.9415 23.2672C17.4206 24.0779 15.7234 24.5013 14 24.5C12.2766 24.5013 10.5794 24.0779 9.05852 23.2672C7.53766 22.4565 6.24001 21.2835 5.28033 19.852C4.36652 18.4898 3.78455 16.9325 3.58109 15.3049C3.37763 13.6772 3.55833 12.0246 4.10871 10.4793C4.65908 8.93412 5.56383 7.53935 6.75041 6.40682C7.937 5.27429 9.37241 4.43552 10.9416 3.95774C12.5108 3.47995 14.1701 3.37645 15.7865 3.65553C17.4028 3.93461 18.9314 4.5885 20.2495 5.5648C21.5676 6.54109 22.6387 7.81262 23.3768 9.27746C24.1149 10.7423 24.4996 12.3597 24.5 14Z" stroke="var(--primary-color)" stroke-width="1.5" />
        <path d="M15.7498 10.5C15.7498 10.9642 15.5654 11.4093 15.2372 11.7375C14.909 12.0657 14.4639 12.25 13.9998 12.25V13.4167C14.3828 13.4167 14.7621 13.3413 15.1159 13.1947C15.4698 13.0481 15.7913 12.8333 16.0622 12.5624C16.333 12.2916 16.5479 11.9701 16.6944 11.6162C16.841 11.2623 16.9165 10.8831 16.9165 10.5H15.7498ZM13.9998 12.25C13.5357 12.25 13.0905 12.0657 12.7623 11.7375C12.4342 11.4093 12.2498 10.9642 12.2498 10.5H11.0831C11.0831 10.8831 11.1586 11.2623 11.3051 11.6162C11.4517 11.9701 11.6666 12.2916 11.9374 12.5624C12.4844 13.1094 13.2262 13.4167 13.9998 13.4167V12.25ZM12.2498 10.5C12.2498 10.0359 12.4342 9.59079 12.7623 9.2626C13.0905 8.93441 13.5357 8.75004 13.9998 8.75004V7.58337C13.2262 7.58337 12.4844 7.89066 11.9374 8.43765C11.3904 8.98463 11.0831 9.72649 11.0831 10.5H12.2498ZM13.9998 8.75004C14.4639 8.75004 14.909 8.93441 15.2372 9.2626C15.5654 9.59079 15.7498 10.0359 15.7498 10.5H16.9165C16.9165 9.72649 16.6092 8.98463 16.0622 8.43765C15.5152 7.89066 14.7733 7.58337 13.9998 7.58337V8.75004ZM6.02679 20.832L5.46679 20.6664L5.37695 20.9709L5.58345 21.2124L6.02679 20.832ZM21.9728 20.832L22.4161 21.2124L22.6226 20.9709L22.5316 20.6664L21.9728 20.832ZM10.4998 18.0834H17.4998V16.9167H10.4998V18.0834ZM10.4998 16.9167C9.36912 16.9165 8.26861 17.2814 7.36198 17.957C6.45536 18.6326 5.78991 19.5829 5.46679 20.6664L6.58562 20.9989C6.83712 20.1562 7.35394 19.4173 8.05918 18.892C8.76442 18.3667 9.6204 18.0831 10.4998 18.0834V16.9167ZM13.9998 23.9167C12.5686 23.9182 11.1541 23.6092 9.85395 23.011C8.55378 22.4128 7.39889 21.5396 6.46895 20.4517L5.58345 21.2124C6.62301 22.4278 7.91379 23.4032 9.3668 24.0715C10.8198 24.7398 12.4005 25.085 13.9998 25.0834V23.9167ZM17.4998 18.0834C18.3793 18.0831 19.2354 18.3669 19.9407 18.8924C20.6459 19.418 21.1627 20.1572 21.414 21L22.5316 20.6664C22.2085 19.5829 21.5442 18.6326 20.6376 17.957C19.731 17.2814 18.6305 16.9165 17.4998 16.9167V18.0834ZM21.5306 20.4517C20.6007 21.5396 19.4458 22.4128 18.1456 23.011C16.8455 23.6092 15.431 23.9182 13.9998 23.9167V25.0834C15.5991 25.085 17.1798 24.7398 18.6328 24.0715C20.0858 23.4032 21.3766 22.4278 22.4161 21.2124L21.5306 20.4517Z" fill="var(--primary-color)" />
        <path d="M15.7498 10.5C15.7498 10.9642 15.5654 11.4093 15.2372 11.7375C14.909 12.0657 14.4639 12.25 13.9998 12.25M15.7498 10.5H16.9165M15.7498 10.5C15.7498 10.0359 15.5654 9.59079 15.2372 9.2626C14.909 8.93441 14.4639 8.75004 13.9998 8.75004M13.9998 12.25V13.4167M13.9998 12.25C13.5357 12.25 13.0905 12.0657 12.7623 11.7375C12.4342 11.4093 12.2498 10.9642 12.2498 10.5M13.9998 13.4167C14.3828 13.4167 14.7621 13.3413 15.1159 13.1947C15.4698 13.0481 15.7913 12.8333 16.0622 12.5624C16.333 12.2916 16.5479 11.9701 16.6944 11.6162C16.841 11.2623 16.9165 10.8831 16.9165 10.5M13.9998 13.4167C13.2262 13.4167 12.4844 13.1094 11.9374 12.5624C11.6666 12.2916 11.4517 11.9701 11.3051 11.6162C11.1586 11.2623 11.0831 10.8831 11.0831 10.5M16.9165 10.5C16.9165 9.72649 16.6092 8.98463 16.0622 8.43765C15.5152 7.89066 14.7733 7.58337 13.9998 7.58337M12.2498 10.5H11.0831M12.2498 10.5C12.2498 10.0359 12.4342 9.59079 12.7623 9.2626C13.0905 8.93441 13.5357 8.75004 13.9998 8.75004M11.0831 10.5C11.0831 9.72649 11.3904 8.98463 11.9374 8.43765C12.4844 7.89066 13.2262 7.58337 13.9998 7.58337M13.9998 8.75004V7.58337M5.46679 20.6664L6.02679 20.832L5.58345 21.2124M5.46679 20.6664L5.37695 20.9709L5.58345 21.2124M5.46679 20.6664C5.78991 19.5829 6.45536 18.6326 7.36198 17.957C8.26861 17.2814 9.36912 16.9165 10.4998 16.9167M5.46679 20.6664L6.58562 20.9989C6.83712 20.1562 7.35394 19.4173 8.05918 18.892C8.76442 18.3667 9.6204 18.0831 10.4998 18.0834M5.58345 21.2124L6.46895 20.4517C7.39889 21.5396 8.55378 22.4128 9.85395 23.011C11.1541 23.6092 12.5686 23.9182 13.9998 23.9167M5.58345 21.2124C6.62301 22.4278 7.91379 23.4032 9.3668 24.0715C10.8198 24.7398 12.4005 25.085 13.9998 25.0834M22.4161 21.2124L21.9728 20.832L22.5316 20.6664M22.4161 21.2124L22.6226 20.9709L22.5316 20.6664M22.4161 21.2124C21.3766 22.4278 20.0858 23.4032 18.6328 24.0715C17.1798 24.7398 15.5991 25.085 13.9998 25.0834M22.4161 21.2124L21.5306 20.4517C20.6007 21.5396 19.4458 22.4128 18.1456 23.011C16.8455 23.6092 15.431 23.9182 13.9998 23.9167M22.5316 20.6664L21.414 21C21.1627 20.1572 20.6459 19.418 19.9407 18.8924C19.2354 18.3669 18.3793 18.0831 17.4998 18.0834M22.5316 20.6664C22.2085 19.5829 21.5442 18.6326 20.6376 17.957C19.731 17.2814 18.6305 16.9165 17.4998 16.9167M10.4998 18.0834H17.4998M10.4998 18.0834V16.9167M17.4998 18.0834V16.9167M17.4998 16.9167H10.4998M13.9998 23.9167V25.0834" stroke="var(--primary-color)" stroke-width="0.5" />
      </svg>
      <span class="profile-title">{{ $t('sidebar.profile') }}</span>
    </div>

    <div class="profile-info">
      <div class="info-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 9C13.933 9 15.5 7.433 15.5 5.5C15.5 3.567 13.933 2 12 2C10.067 2 8.5 3.567 8.5 5.5C8.5 7.433 10.067 9 12 9Z" stroke="var(--primary-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M2 20.5C2 16.0815 6.0295 12.5 11 12.5M15.5 21L20.5 16L18.5 14L13.5 19V21H15.5Z" stroke="var(--primary-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{{ displayName }}</span>
      </div>

      <div class="info-item">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z" stroke="var(--primary-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{{ $t('sidebar.role') }}: {{ userRole || $t('sidebar.no_role') }}</span>
      </div>

      <div class="info-item" style="border-bottom: 1px solid #eee">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M3 5V4.25C2.80109 4.25 2.61032 4.32902 2.46967 4.46967C2.32902 4.61032 2.25 4.80109 2.25 5H3ZM21 5H21.75C21.75 4.80109 21.671 4.61032 21.5303 4.46967C21.3897 4.32902 21.1989 4.25 21 4.25V5ZM3 5.75H21V4.25H3V5.75ZM20.25 5V17H21.75V5H20.25ZM19 18.25H5V19.75H19V18.25ZM3.75 17V5H2.25V17H3.75ZM5 18.25C4.31 18.25 3.75 17.69 3.75 17H2.25C2.25 17.7293 2.53973 18.4288 3.05546 18.9445C3.57118 19.4603 4.27065 19.75 5 19.75V18.25ZM20.25 17C20.25 17.69 19.69 18.25 19 18.25V19.75C19.7293 19.75 20.4288 19.4603 20.9445 18.9445C21.4603 18.4288 21.75 17.7293 21.75 17H20.25Z" fill="var(--primary-color)" />
          <path d="M3 5L12 14L21 5" stroke="var(--primary-color)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span>{{ userData?.email_id || $t('sidebar.no_email') }}</span>
      </div>

      <div class="info-item" style="margin-top: 9px" @click="goToChangeLanguage">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M20.5801 19.3699L17.5901 11.0099C17.3801 10.4599 16.9101 10.1199 16.3701 10.1199C15.8301 10.1199 15.3701 10.4599 15.1401 11.0299L12.1601 19.3699C12.1234 19.4632 12.1057 19.5629 12.1081 19.6631C12.1106 19.7634 12.1331 19.8621 12.1744 19.9535C12.2156 20.0449 12.2748 20.1271 12.3484 20.1952C12.422 20.2633 12.5085 20.316 12.6028 20.3501C12.6971 20.3842 12.7973 20.3991 12.8974 20.3938C12.9976 20.3885 13.0956 20.3632 13.1858 20.3194C13.276 20.2755 13.3565 20.214 13.4225 20.1385C13.4885 20.0631 13.5387 19.9751 13.5701 19.8799L14.1901 18.1499H18.5401L19.1601 19.8799C19.2701 20.1899 19.5601 20.3799 19.8701 20.3799C19.9501 20.3799 20.0401 20.3699 20.1201 20.3399C20.307 20.2722 20.4594 20.133 20.5438 19.953C20.6282 19.773 20.6377 19.5669 20.5701 19.3799L20.5801 19.3699ZM14.7401 16.6399L16.3801 12.0499L18.0201 16.6399H14.7401ZM12.1901 7.84988C9.93012 11.4199 7.89012 13.5799 5.41012 15.0199C5.32542 15.0691 5.23184 15.1012 5.13474 15.1143C5.03764 15.1274 4.93891 15.1212 4.84419 15.0962C4.74947 15.0711 4.66062 15.0276 4.58271 14.9682C4.5048 14.9088 4.43935 14.8346 4.39012 14.7499C4.34006 14.6654 4.30731 14.5718 4.2938 14.4745C4.28028 14.3772 4.28626 14.2782 4.3114 14.1833C4.33653 14.0884 4.3803 13.9994 4.44017 13.9215C4.50004 13.8437 4.57481 13.7785 4.66012 13.7299C6.76012 12.5099 8.48012 10.7599 10.4101 7.85988H4.12012C3.71012 7.85988 3.37012 7.51988 3.37012 7.10988C3.37012 6.69988 3.71012 6.35988 4.12012 6.35988H7.87012V4.37988C7.87012 3.96988 8.21012 3.62988 8.62012 3.62988C9.03012 3.62988 9.37012 3.96988 9.37012 4.37988V6.35988H13.1201C13.5301 6.35988 13.8701 6.69988 13.8701 7.10988C13.8701 7.51988 13.5301 7.85988 13.1201 7.85988H12.1801L12.1901 7.84988ZM12.2301 15.1199C12.1001 15.1199 11.9701 15.0899 11.8501 15.0199C11.2001 14.6399 10.5701 14.2199 9.98012 13.7799C9.82099 13.6605 9.71579 13.4829 9.68766 13.2859C9.65952 13.089 9.71077 12.889 9.83012 12.7299C9.94946 12.5708 10.1271 12.4656 10.3241 12.4374C10.521 12.4093 10.721 12.4605 10.8801 12.5799C11.4201 12.9899 12.0101 13.3699 12.6101 13.7199C12.7522 13.8035 12.8628 13.9315 12.925 14.0842C12.9872 14.2369 12.9975 14.4058 12.9543 14.5649C12.9111 14.724 12.8168 14.8645 12.686 14.9647C12.5551 15.065 12.395 15.1195 12.2301 15.1199Z" fill="var(--primary-color)" />
        </svg>
        <span>{{ $t('sidebar.language') }}</span>
      </div>

      <div class="info-item logout" @click="handleLogout">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12 3.25C12.1989 3.25 12.3897 3.32902 12.5303 3.46967C12.671 3.61032 12.75 3.80109 12.75 4C12.75 4.19891 12.671 4.38968 12.5303 4.53033C12.3897 4.67098 12.1989 4.75 12 4.75C10.0772 4.75 8.23311 5.51384 6.87348 6.87348C5.51384 8.23311 4.75 10.0772 4.75 12C4.75 13.9228 5.51384 15.7669 6.87348 17.1265C8.23311 18.4862 10.0772 19.25 12 19.25C12.1989 19.25 12.3897 19.329 12.5303 19.4697C12.671 19.6103 12.75 19.8011 12.75 20C12.75 20.1989 12.671 20.3897 12.5303 20.5303C12.3897 20.671 12.1989 20.75 12 20.75C9.67936 20.75 7.45376 19.8281 5.81282 18.1872C4.17187 16.5462 3.25 14.3206 3.25 12C3.25 9.67936 4.17187 7.45376 5.81282 5.81282C7.45376 4.17187 9.67936 3.25 12 3.25Z" fill="var(--primary-color)" />
          <path d="M16.47 9.53009C16.3375 9.38792 16.2654 9.19987 16.2688 9.00557C16.2723 8.81127 16.351 8.62588 16.4884 8.48847C16.6258 8.35106 16.8112 8.27234 17.0055 8.26892C17.1998 8.26549 17.3878 8.33761 17.53 8.47009L20.53 11.4701C20.6705 11.6107 20.7493 11.8013 20.7493 12.0001C20.7493 12.1988 20.6705 12.3895 20.53 12.5301L17.53 15.5301C17.4613 15.6038 17.3785 15.6629 17.2865 15.7039C17.1945 15.7449 17.0952 15.7669 16.9945 15.7687C16.8938 15.7705 16.7938 15.7519 16.7004 15.7142C16.607 15.6765 16.5222 15.6203 16.451 15.5491C16.3797 15.4779 16.3236 15.3931 16.2859 15.2997C16.2482 15.2063 16.2296 15.1063 16.2314 15.0056C16.2332 14.9049 16.2552 14.8056 16.2962 14.7136C16.3372 14.6216 16.3963 14.5388 16.47 14.4701L18.19 12.7501H10C9.80109 12.7501 9.61032 12.6711 9.46967 12.5304C9.32902 12.3898 9.25 12.199 9.25 12.0001C9.25 11.8012 9.32902 11.6104 9.46967 11.4698C9.61032 11.3291 9.80109 11.2501 10 11.2501H18.19L16.47 9.53009Z" fill="var(--primary-color)" />
        </svg>
        <span>{{ $t('sidebar.logout') }}</span>
      </div>
    </div>
  </div>

  <!-- Tenant Selection Popup for Super Admin -->
  <TenantSelectionPopup :show="showTenantSelectionPopup" @close="showTenantSelectionPopup = false" @select="handleTenantSelect" />
</template>

<script>
import whiteLogo from '@/assets/mainBanner.png'
import helpIcon from '@/assets/help.png'
import logoutIcon from '@/assets/logout.png'
import { useTenantStore } from '@/stores/tenantStore'
import TenantSelectionPopup from './TenantSelectionPopup.vue'
import tenantSelectionStore from '@/stores/tenantSelectionStore'

import { isAiMethodBedrock } from '@/utils/tenantUtils.js'
export default {
  components: {
    TenantSelectionPopup,
  },
  data() {
    return {
      whiteLogo,
      helpIcon,
      logoutIcon,
      showTenantSelectionPopup: false,
      menuItems: [],
      showProfilePopover: false,
      userData: null,
      userRole: '',
      showLogoutConfirm: false,
      isLogoLoading: true,
      tenantSelectionState: {
        selectedTenantUsesBedrock: false,
        selectedTenantId: '',
        userRole: '',
        loadingTenantAiMethod: false,
      },
    }
  },
  computed: {
    tenant() {
      const store = useTenantStore()
      return store
    },
    isBedrock() {
      // Use centralized tenant selection store for consistent AI method detection
      return this.tenantSelectionState.selectedTenantUsesBedrock
    },
    displayName() {
      if (this.userData) {
        // If first_name and last_name exist, use them
        if (this.userData.first_name && this.userData.last_name) {
          return `${this.userData.first_name} ${this.userData.last_name}`
        }
        // If either first_name or last_name exists
        if (this.userData.first_name || this.userData.last_name) {
          return this.userData.first_name || this.userData.last_name
        }
        // If no name, extract from email
        if (this.userData.email_id) {
          return this.userData.email_id
            .split('@')[0]
            .split('.')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
        }
        // Fallback
        return 'User'
      }
      return 'User'
    },
    profileInitials() {
      if (this.displayName) {
        return this.displayName
          .split(' ')
          .map((n) => n[0])
          .join('')
          .toUpperCase()
          .slice(0, 2)
      }
      return 'U'
    },
  },
  created() {
    // Get and store user role FIRST (needed for tenant store logic)
    const userRolesString = localStorage.getItem('UserRoles')
    try {
      const userRoles = JSON.parse(userRolesString)
      this.userRole = userRoles[0]?.role?.roleName || ''
    } catch (e) {
      this.userRole = ''
    }
    console.log('Sidebar: User role determined:', this.userRole)

    // Subscribe to tenant selection store changes
    this.unsubscribeFromTenantStore = tenantSelectionStore.subscribe((state) => {
      console.log('Sidebar: Store state change received:', state)
      this.tenantSelectionState = { ...state }
      // Re-render menu items when bedrock status changes
      this.$nextTick(() => {
        console.log('Sidebar: Re-rendering menu items due to store change')
        this.updateMenuItems()
      })
    })

    // Get initial state from tenant store
    this.tenantSelectionState = tenantSelectionStore.getCurrentState()
    console.log('Sidebar: Initial tenant store state:', this.tenantSelectionState)
    console.log('Sidebar: localStorage selectedTenantUsesBedrock:', localStorage.getItem('selectedTenantUsesBedrock'))

    // Get user data from localStorage
    const userDataString = localStorage.getItem('UserData')

    if (userDataString) {
      try {
        this.userData = JSON.parse(userDataString)
        // Initialize tenant store with user's tenant ID
        const tenantStore = useTenantStore()
        if (this.userData.tenant_id) {
          tenantStore
            .fetchTenantConfigs(this.userData.tenant_id)
            .then(() => {
              // Set loading to false after tenant configs are fetched
              this.isLogoLoading = false
            })
            .catch((error) => {
              this.isLogoLoading = false
            })
        } else {
          this.isLogoLoading = false
        }
      } catch (e) {
        this.isLogoLoading = false
      }
    } else {
      this.isLogoLoading = false
    }

    // Add click outside handler
    document.addEventListener('click', this.handleClickOutside)

    // User role already set above

    // For regular users, ensure AI method is available (async if needed)
    if (this.userRole !== 'Super Admin') {
      // Check if we need to initialize AI method
      const cachedBedrock = localStorage.getItem('selectedTenantUsesBedrock')
      if (cachedBedrock === null && this.tenantSelectionState.selectedTenantId) {
        console.log('Sidebar: Need to fetch AI method for regular user')
        tenantSelectionStore.initializeRegularUserAiMethod().then(() => {
          console.log('Sidebar: Regular user AI method initialized')
          this.tenantSelectionState = tenantSelectionStore.getCurrentState()
          this.updateMenuItems()
        })
      } else {
        console.log('Sidebar: Using cached bedrock status:', cachedBedrock)
      }
    }

    // Initialize menu items
    this.updateMenuItems()

    // Check active route immediately after setting menu items
    this.$nextTick(() => {
      this.checkActiveRoute()
    })
  },
  mounted() {
    // Check active route when component is mounted
    this.checkActiveRoute()

    // Make sidebar available for debugging
    window.debugSidebar = () => {
      console.log('=== Sidebar Debug Info ===')
      console.log('User role:', this.userRole)
      console.log('isBedrock computed:', this.isBedrock)
      console.log('tenantSelectionState:', this.tenantSelectionState)
      console.log(
        'Configure menu item:',
        this.menuItems?.find((item) => item.text === 'Configure')
      )
      console.log('All menu items:', this.menuItems)
      this.refreshTenantState()
    }
  },
  beforeUnmount() {
    // Cleanup tenant store subscription
    if (this.unsubscribeFromTenantStore) {
      this.unsubscribeFromTenantStore()
    }
  },
  methods: {
    updateMenuItems() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      const dashboardrdReadPermission = permissions.some((p) => p.object_name === 'DASHBOARD_RD' && p.is_active)
      const jobHistoryReadPermission = permissions.some((p) => p.object_name === 'JOB_HISTORY_RD' && p.is_active) && this.userRole !== 'Super Admin'
      const newJobReadPermission = permissions.some((p) => p.object_name === 'NEW_JOB_RD' && p.is_active) && this.userRole !== 'Super Admin'
      const usersReadPermission = permissions.some((p) => p.object_name === 'USERS_RD' && p.is_active)
      const tenantReadPermission = permissions.some((p) => p.object_name === 'TENANT_CONFIGURE_RD' && p.is_active)
      const reportsReadPermission = permissions.some((p) => p.object_name === 'REPORTS_RD' && p.is_active)

      // Define base menu items with dynamic configure path
      const allMenuItems = [
        ...(dashboardrdReadPermission
          ? [
              {
                text: 'Dashboard',
                icon: '/dashboard.png',
                active: false,
                path: 'dashboard',
                sequence: 1,
              },
            ]
          : []),
        ...(jobHistoryReadPermission
          ? [
              {
                text: 'Job History',
                icon: '/job_history.png',
                active: false,
                path: 'job-history',
                sequence: 2,
              },
            ]
          : []),
        ...(newJobReadPermission
          ? [
              {
                text: 'New Job',
                icon: '/new_job.png',
                active: false,
                path: 'new-job',
                sequence: 2,
              },
            ]
          : []),
        ...(tenantReadPermission && this.userRole !== 'Tenant User'
          ? [
              {
                text: 'Tenants',
                icon: '/ph_user-list.png',
                active: false,
                path: 'tenant-management',
                sequence: 3,
              },
            ]
          : []),
        ...(usersReadPermission && this.userRole !== 'Tenant User'
          ? [
              {
                text: 'Users',
                icon: '/ph_users-three.png',
                active: false,
                path: 'users-management',
                sequence: 4,
              },
            ]
          : []),
        ...(reportsReadPermission
          ? [
              {
                text: 'Reports',
                icon: '/reportIcon.svg',
                active: false,
                path: 'reports',
                sequence: 5,
              },
            ]
          : []),
        ...(this.userRole !== 'Tenant User'
          ? [
              {
                text: 'Configure',
                icon: '/settings.png',
                active: false,
                path: this.isBedrock ? 'configure/document-types' : 'configure/categories',
                sequence: 6,
              },
            ]
          : []),
      ]

      this.menuItems = allMenuItems.sort((a, b) => a.sequence - b.sequence)
      console.log('Sidebar: Menu items updated, isBedrock:', this.isBedrock, 'Configure path:', this.menuItems.find((item) => item.text === 'Configure')?.path)
    },
    async handleTenantSelect(tenant) {
      console.log('\ud83c\udfe2 Sidebar: Tenant selected from popup:', tenant)

      // Store tenant details for other parts of app
      localStorage.setItem(
        'selectedTenant',
        JSON.stringify({
          ...tenant,
          url_name: tenant.name.toLowerCase().replace(/[^a-z0-9]/g, ''),
        })
      )

      // PURE STORE APPROACH: Update store directly
      console.log('\ud83c\udfe2 Sidebar: Updating store with tenant:', tenant.id)
      await tenantSelectionStore.setSelectedTenantId(tenant.id)

      console.log('\ud83c\udfe2 Sidebar: Store updated successfully')

      // Close popup
      this.showTenantSelectionPopup = false

      // Navigate to configure/document-types page (NO query parameters needed)
      const tenantName = localStorage.getItem('url_name')
      if (tenantName) {
        this.$router.push(`/${tenantName}/configure/document-types`)
      }
    },

    handleClickOutside(event) {
      const profileButton = event.target.closest('.menu-item')
      const profilePopover = event.target.closest('.profile-popover')

      if (!profileButton && !profilePopover && this.showProfilePopover) {
        this.showProfilePopover = false
      }
    },
    isSameConfigureSection(selectedItemPath) {
      const currentPath = window.location.pathname
      const parts = currentPath.split('/')
      const afterSecondSlash = parts.slice(2).join('/') // e.g. "configure/document-types"

      return selectedItemPath.startsWith('configure/') && afterSecondSlash.startsWith('configure')
    },
    setActive(selectedItem) {
      // if user clicking on configure path and if it is currently active
      const isSamePath = this.isSameConfigureSection(selectedItem.path)
      if (isSamePath) return
      // For Super Admin, show tenant selection popup before Configure
      if (this.userRole === 'Super Admin' && selectedItem.path.startsWith('configure/')) {
        this.showTenantSelectionPopup = true
        return
      }

      this.menuItems.forEach((item) => {
        item.active = item === selectedItem
      })
      const tenantName = localStorage.getItem('url_name')
      if (tenantName) {
        this.$router.push(`/${tenantName}/${selectedItem.path}`)
      } else {
        this.$router.push(`/${selectedItem.path}`)
      }
    },
    toggleProfilePopover() {
      this.showProfilePopover = !this.showProfilePopover
    },
    handleLogout() {
      this.showLogoutConfirm = true
    },
    confirmLogout() {
      const tenantName = localStorage.getItem('url_name')
      localStorage.clear()
      window.location.href = `/tenant/${tenantName}`
    },
    checkActiveRoute() {
      const currentPath = this.$route.path
      const tenantName = localStorage.getItem('url_name')
      this.menuItems.forEach((item) => {
        let isActive = false
        const basePath = tenantName ? `/${tenantName}/${item.path}` : `/${item.path}`

        switch (item.path) {
          case 'dashboard':
            isActive = currentPath === basePath
            break
          case 'job-history':
            isActive = currentPath === basePath || currentPath.startsWith(tenantName ? `/${tenantName}/view-document` : '/view-document')
            break
          case 'new-job':
            isActive = currentPath === basePath || currentPath === (tenantName ? `/${tenantName}/upload-status` : '/upload-status')
            break
          case 'tenant-management':
            isActive = currentPath === basePath || currentPath === (tenantName ? `/${tenantName}/tenant/add` : '/tenant/add')
            break
          case 'users-management':
            isActive = currentPath === basePath || currentPath === (tenantName ? `/${tenantName}/create-user` : '/create-user') || currentPath.startsWith(tenantName ? `/${tenantName}/edit-user/` : '/edit-user/')
            break
          // Add reports case
          case 'reports':
            isActive = currentPath === basePath || currentPath.startsWith(tenantName ? `/${tenantName}/reports` : '/reports')
            break
          case 'configure':
            // Handle non-Bedrock configure path
            isActive = currentPath === basePath || currentPath.startsWith(tenantName ? `/${tenantName}/configure/categories` : '/configure/categories')
            break
          case 'configure/categories': {
            const currentUrl = window.location.href
            const tenantName = localStorage.getItem('url_name')
            // Check if current URL contains tenant name followed by /configure
            isActive = currentPath === basePath || currentPath.startsWith(tenantName ? `/${tenantName}/configure/categories` : '/configure/categories') || (tenantName && currentUrl.includes(`/${tenantName}/configure`))
            break
          }
          case 'configure/document-types': {
            // Handle Bedrock configure path
            const tenantName = localStorage.getItem('url_name')
            const expectedPath = tenantName ? `/${tenantName}/configure/document-types` : '/configure/document-types'
            isActive = currentPath === expectedPath || currentPath.startsWith(expectedPath) || (tenantName && (currentPath.includes(`/${tenantName}/configure/document-types`) || currentPath.includes(`/${tenantName}/train-document`) || currentPath.includes(`/${tenantName}/edit-document`)))
            break
          }
          default:
            isActive = false
        }
        item.active = isActive
      })
    },
    handleLogoError(e) {
      this.isLogoLoading = false
      e.target.src = this.whiteLogo
    },
    handleLogoLoad() {
      this.isLogoLoading = false
    },
    goToChangeLanguage() {
      const tenantName = localStorage.getItem('url_name')
      this.$router.push(`/${tenantName}/change-language`)
      this.showProfilePopover = false
    },

    // Debug method to force refresh tenant state
    refreshTenantState() {
      console.log('Sidebar: Forcing tenant state refresh')
      this.tenantSelectionState = tenantSelectionStore.getCurrentState()
      this.updateMenuItems()
      console.log('Sidebar: After refresh - isBedrock:', this.isBedrock)
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.checkActiveRoute()
      },
    },
  },
}
</script>

<style scoped>
.menu-item {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
}
.active-dot {
  width: 3px;
  height: 63px;
  flex-shrink: 0;
  background-color: var(--primary-color);
  margin-left: 10px;
}
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 155px;
  height: 100vh;
  background-color: var(--primary-color);
  color: #fff;
  display: flex !important;
  flex-direction: column !important;
  justify-content: space-between !important;
  /* gap: 36px; */
  /* padding: 10px; */
  /* background-color: red; */
}

.sidebar-header {
  width: 100%;
  max-width: 200px;
  max-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-bottom: 15px;
  margin-top: 5px;
  overflow: hidden;
}

.sidebar-header img {
  max-width: 100%;
  max-height: 100%;
  height: auto;
  width: auto;
  object-fit: contain;
}

.menu-list {
  list-style: none;
  padding: 0;
  /* background-color: red; */
  height: 100%;
  margin: 0;
}

.menu-text {
  margin-top: 6px;
}

.menu-list li a {
  display: flex;
  align-items: center;
  padding: 15px 10px;
  font-family: 'Archivo', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-decoration: none;
  text-align: center;
  margin: 0px 14px;
}

.menu-list li.active a {
  background-color: rgba(var(--secondary-color-rgb), 0.5);
  margin: 0px 14px;
  border-left: 3px solid rgba(var(--secondary-color-rgb), 0.8);
}

.bottom {
  margin-bottom: 20px;
}
.profileText {
  color: var(--primary-color);
  text-align: center;
  font-family: 'Work Sans';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.profileDiv {
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  background-color: var(--secondary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profile-popover {
  position: fixed;
  left: 10%;
  bottom: 120px; /* Adjust as needed to align with profile button */
  transform: translateX(-50%);
  width: 255px;
  max-width: 90vw;
  height: auto;
  max-height: 80vh;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1100;
  padding-left: 9px;
  overflow: auto;
}

.profile-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 9px;
  border-bottom: 1px solid #eee;
}

.profile-title {
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 18px;
  font-weight: 700;
}

.profile-info {
  padding: 9px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  color: #5c656c;
  font-family: Archivo;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  cursor: pointer;
}

.logout {
  color: #dc5447;
  margin-top: 9px;
  border-top: 1px solid #eee;
  padding-top: 9px;
}

.logout-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.logout-modal {
  display: flex;
  width: 405px;
  height: 296px;
  padding: 24px 40px 23px 40px;
  align-items: center;
  flex-direction: column;
  background: white;
  border-radius: 8px;
}

.logout-icon {
  display: flex;
  width: 100px;
  height: 100px;
  padding: var(--Micro-XL, 12px);
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  background-color: #ffe2e0;
}

.logout-title {
  color: #dc5447;
  text-align: center;
  font-family: Archivo;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 7px;
  margin-top: 8px;
}

.logout-message {
  overflow: hidden;
  color: #667085;
  text-align: center;
  text-overflow: ellipsis;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
  margin-bottom: 20px;
}

.logout-actions {
  display: flex;
  gap: 16px;
}

.logout-btn {
  display: flex;
  width: 137.887px;
  height: 40.605px;
  padding: 15px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #dc5447;
  color: #fff;
  text-align: center;
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0.14px;
  border: none;
  cursor: pointer;
}

.cancel-btn {
  display: flex;
  width: 137.887px;
  height: 40.605px;
  padding: 15px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 2px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
  font-family: Archivo;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  cursor: pointer;
}

.mainLogoutIcon {
  width: 57px;
  height: 54px;
  flex-shrink: 0;
}

.logo-placeholder {
  width: 128px;
  height: 25px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}
</style>
